import { defineFcm } from '../shared/factory';

export const FCM_EXPORT_SERVICE = defineFcm('export_service').asBoolean().withDefault(false).toConfig();
